import actionTypes from "../actions/actionTypes";

const initialState = {
  teachers: [],
  loading: false,
  error: null,
  successMessage: null,
  messages: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADMIN_REQUEST_START: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case actionTypes.ADMIN_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        successMessage: action.data,
      };
    }
    case actionTypes.ADMIN_REQUEST_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.data,
      };
    }
    case actionTypes.CLEAR_ADMIN_REDUCER_STATE: {
      return {
        teachers: [],
        loading: false,
        error: null,
        successMessage: null,
        messages: [],
      };
    }
    case actionTypes.GET_TEACHERS: {
      const updatedTeachers = [...action.data];
      return {
        ...state,
        teachers: updatedTeachers,
      };
    }
    case actionTypes.ADD_TEACHER: {
      const updatedTeachers = [...state.teachers];
      updatedTeachers.push({ emailId: action.data });
      return {
        ...state,
        teachers: updatedTeachers,
      };
    }
    case actionTypes.DELETE_TEACHER: {
      const updatedTeachers = state.teachers.filter(
        (teacher) => teacher.emailId !== action.data,
      );
      return {
        ...state,
        teachers: updatedTeachers,
      };
    }
    case actionTypes.UPDATE_TEACHER: {
      const updatedTeachers = state.teachers.map((teacher) => {
        if (teacher.emailId === action.emailId) {
          return action.newEmailId;
        }
        return teacher;
      });
      return {
        ...state,
        teachers: updatedTeachers,
      };
    }
    case actionTypes.CLEAR_ADMIN_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    case actionTypes.CLEAR_ADMIN_SUCCESS: {
      return {
        ...state,
        successMessage: null,
      };
    }
    case actionTypes.GET_CUSTOM_MESSAGES: {
      const updatedMessages = [...action.data];
      return {
        ...state,
        messages: updatedMessages,
      };
    }
    case actionTypes.REMOVE_RANDOM_MESSAGE: {
      const updatedMessages = state.messages.filter(
        (message) => message.referenceId !== action.data,
      );
      return {
        ...state,
        messages: updatedMessages,
      };
    }
    case actionTypes.UPDATE_TEACHER_MESSAGE: {
      const updatedTeachers = state.teachers.map((teacher) => {
        if (teacher.emailId === action.data.teacherId) {
          // eslint-disable-next-line no-param-reassign
          teacher.teacherMessage = action.data.teacherMessage;
        }
        return teacher;
      });
      return {
        ...state,
        teachers: updatedTeachers,
      };
    }
    default:
      return state;
  }
};

export default reducer;
